var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document 1",
    clipPath: "url(#clip0_4434_110305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3193",
    d: "M12.5301 1.15729e-06H1.94188C1.68715 -0.000277088 1.43485 0.0496209 1.19941 0.146846C0.963955 0.244072 0.749962 0.38672 0.569641 0.566647C0.389321 0.746574 0.246205 0.960257 0.148466 1.19549C0.0507267 1.43073 0.000277942 1.68291 0 1.93765V16.0624C0.000560528 16.5761 0.204885 17.0686 0.568143 17.4319C0.9314 17.7951 1.42392 17.9994 1.93765 18H12.5259C13.0396 17.9994 13.5321 17.7951 13.8954 17.4319C14.2586 17.0686 14.463 16.5761 14.4635 16.0624V1.93765C14.463 1.42466 14.2592 0.932773 13.8969 0.569636C13.5345 0.206499 13.0431 0.00168096 12.5301 1.15729e-06ZM13.176 16.0624C13.176 16.2337 13.108 16.3979 12.9868 16.5191C12.8657 16.6402 12.7014 16.7082 12.5301 16.7082H1.94188C1.77058 16.7082 1.6063 16.6402 1.48517 16.5191C1.36405 16.3979 1.296 16.2337 1.296 16.0624V1.93765C1.29628 1.76644 1.36442 1.60232 1.48548 1.48125C1.60655 1.36018 1.77067 1.29205 1.94188 1.29177H12.5301C12.7014 1.29177 12.8657 1.35981 12.9868 1.48094C13.108 1.60207 13.176 1.76635 13.176 1.93765V16.0624Z",
    fill: "#347AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 468",
    d: "M11.4316 4.59375H3.03516V5.88551H11.4316V4.59375Z",
    fill: "#347AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 469",
    d: "M11.4316 8.08203H3.03516V9.3738H11.4316V8.08203Z",
    fill: "#347AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 470",
    d: "M11.4316 11.5703H3.03516V12.8621H11.4316V11.5703Z",
    fill: "#347AF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4434_110305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4678,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTemplate);
export default __webpack_public_path__ + "static/media/editTemplate.04f486c43f53bfb8c399de66238fa3e9.svg";
export { ForwardRef as ReactComponent };